import { render, staticRenderFns } from "./BrandIndex.vue?vue&type=template&id=6a92a5bb&scoped=true"
import script from "./BrandIndex.vue?vue&type=script&lang=js"
export * from "./BrandIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a92a5bb",
  null
  
)

export default component.exports